import React, {FunctionComponent} from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

const IconFeedback: FunctionComponent<IconProps> = ({
  className, height, title,
}) =>
  (
    <Icon className={className} height={height} title={title}>
      M3.77483 13.9614L3.46389 14.8276C3.13999 15.7298 2.64523 16.5379 2.23589 17.1162C3.6245 16.8688 4.75775 16.2598
      5.50324 15.72L6.11097 15.2799L6.8276 15.5023C7.8182 15.8097 8.87796 15.9812 10.0116 15.9812C14.9929 15.9812 18.5
      12.7463 18.5 9.36558C18.5 6.01977 14.9878 2.75 10.0116 2.75C5.00046 2.75 1.5232 6.01643 1.5232 9.36558C1.5232
      10.823 2.09495 12.1797 3.14348 13.2917L3.77483 13.9614ZM0.531143 18.6434C0.429254 18.5992 0.336526 18.5385
      0.257303 18.4623C0.176816 18.3849 0.110269 18.2916 0.0622154 18.1835C-0.0548362 17.8323 -0.0158176 17.4421
      0.257303 17.169C0.29632 17.169 1.50585 15.8424 2.05209 14.3208C0.764526 12.9552 0.0231986 11.2384 0.0231986
      9.36558C0.0231986 4.91762 4.47116 1.25 10.0116 1.25C15.513 1.25 20 4.91762 20 9.36558C20 13.8526 15.513 17.4812
      10.0116 17.4812C8.72404 17.4812 7.5145 17.2861 6.383 16.9349C5.2515 17.7543 3.33966 18.7297 0.959611
      18.7297C0.80782 18.7297 0.661934 18.7002 0.531143 18.6434Z</Icon>
  );

export default IconFeedback;
